import { wafPaths } from './paths';

// Plain data: no console, no loader (the entry chunk reads it; route.ts stays lazy).
/** Provider scopes this module serves in the service catalog. */
export const serviceScopes = [
  // Owl/Mlytics rides the CDN category catalog-wise but opens this module's own WAF/CDN console
  // (dedicated /api/v3/waf), not the shared CDN shell.
  { scope: 'External.Mlytics', category: 'cdn', route: (id: string) => `${wafPaths.base}/${id}` },
] as const;
